export const THEME_WHITE = 'white';
export const THEME_LIGHT = 'light';
